export function DecoBar(props: { className?: string }) {
  return (
    <svg
      width="8"
      height="331"
      viewBox="0 0 8 331"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <rect width="8" height="331" fill="url(#paint0_linear_160_21683)" />
      <defs>
        <linearGradient
          id="paint0_linear_160_21683"
          x1="-0.000120468"
          y1="-105.471"
          x2="0.388971"
          y2="273.776"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#82D200" />
          <stop offset="0.505653" stopColor="#0EBC73" />
          <stop offset="0.8" stopColor="#08C1F3" stopOpacity="0.66" />
          <stop offset="1" stopColor="#08C1F3" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
